import RestrictedComponent from "common/components/RestrictedComponent";

import SettingsScrollContent from "../SettingsScrollContent";
import DeleteWorkspace from "./DeleteWorkspace";
import WorkspaceName from "./WorkspaceName";
import WorkspacePicture from "./WorkspacePicture";

export default function General() {
  return (
    <SettingsScrollContent>
      <div>
        <WorkspacePicture />
        <WorkspaceName />
        <RestrictedComponent visibleFor="owner">
          <DeleteWorkspace />
        </RestrictedComponent>
      </div>
    </SettingsScrollContent>
  );
}
